module.exports = __webpack_public_path__ + "static/media/auto-main-icon.d1bbb8f0.svg";